import {LoggerRessource} from './rest/logger-ressource.service';
import {Inject, Injectable} from '@angular/core';
import {LIB_AUTH_SERVICE_TOKEN, LibAuthService} from '../components/chatbot/libAuthService';
import {firstValueFrom, startWith} from 'rxjs';

@Injectable({providedIn: 'root'})
export class CSPReporter {

    constructor(private logger: LoggerRessource,
                @Inject(LIB_AUTH_SERVICE_TOKEN) private authService: LibAuthService) {
    }

    public initialize(): void {
        document.addEventListener('securitypolicyviolation', async (event: SecurityPolicyViolationEvent) => {
            const data = {
                url: window.location.href,
                cspData: {
                    blockedURI: event.blockedURI,
                    documentURI: event.documentURI,
                    originalPolicy: event.originalPolicy,
                    effectiveDirective: event.effectiveDirective,
                    referrer: event.referrer,
                    violatedDirective: event.violatedDirective,
                    statusCode: event.statusCode,
                    sourceFile: event.sourceFile,
                    lineNumber: event.lineNumber,
                    columnNumber: event.columnNumber,
                    sample: event.sample,
                    disposition: event.disposition
                }
            };

            const user = await firstValueFrom(this.authService.authentication$.pipe(startWith(undefined)));
            this.logger.logFrontendInfoToBackend(`CSP ERROR: ${JSON.stringify(data)}`, user);
        });
    }
}
